import { css } from 'emotion'
import AuthBgd from './../../static/login.jpg'
import { Subtitle } from './..'

export const AuthStyle = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  position: 'relative',
  padding: '30px 0px',
  background: `white url(${AuthBgd}) no-repeat top left`,
  backgroundSize: 'contain',
  minHeight: '100vh',
  textAlign: 'center',
  '@media (min-width: 1024px)': {
    padding: '50px 0px',
    backgroundSize: 'auto 100%',
  },
  '.logo' : {
    margin: '0px auto',
    height: 22,
    '@media (min-width: 1024px) and (min-height: 800px)': {
      height: 'auto',
    }
  },
  'h2' : {
    ...Subtitle,
    margin: 0,
  },
  '.auth--container': {
    margin: '0px auto',
    marginTop: '8vh',
    padding: '0 2rem',
    width: '100%',
    maxWidth: 420,
    '@media (min-width: 1024px)': {
      padding: '0',
    },
    '@media (min-height: 800px)': {
      marginTop: '11.25rem',
    },
  },
  '.auth--middle': {
    width: '100%',
  }
})


// WEBPACK FOOTER //
// ./src/styles/auth/layout.js